import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import SummaryApi from '../common';
import VerticalCard from '../components/VerticalCard';

const SearchProduct = () => {
  const location = useLocation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchProduct = useCallback(async () => {
    if (!location.search) {
      setData([]);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(SummaryApi.searchProduct.url + location.search);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const dataResponse = await response.json();
      setData(dataResponse?.data || []);
    } catch (error) {
      console.error("Error fetching search results:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [location.search]);

  useEffect(() => {
    fetchProduct();
  }, [fetchProduct]);

  return (
    <div className='container mx-auto p-4'>
      {loading && (
        <p className='text-lg text-center text-slate-600'>Loading...</p>
      )}

      <p className='text-lg font-semibold my-3 text-slate-800'>
        Search Results: {data.length}
      </p>

      {data.length === 0 && !loading && (
        <div className='bg-white text-center p-8 rounded shadow'>
          <p className='text-lg text-slate-600'>
            No results found for your search.
          </p>
          <p className='text-sm text-slate-500 mt-2'>
            Try different keywords or browse our categories.
          </p>
        </div>
      )}

      {data.length > 0 && !loading && (
        <VerticalCard loading={loading} data={data} />
      )}
    </div>
  );
};

export default SearchProduct;